<footer class="footer">
    <div class="container text-center">
        <a class="btn btn-default btn-round btn-lg btn-icon" href="https://www.linkedin.com/in/nisa-champagne-32782b182/"
          target="_blank" rel="tooltip" title="Check out my Linkedin Profile">
          <i class="fa fa-linkedin"></i>
        </a>
        <a class="btn btn-default btn-round btn-lg btn-icon" href="https://github.com/nisaChampagne"
          target="_blank" rel="tooltip" title="Follow me on Github">
          <i class="fa fa-github"></i>
        </a>
        <a class="btn btn-default btn-round btn-lg btn-icon" href="https://twitter.com/nisa_Champagne"
          target="_blank" rel="tooltip" title="Follow me on Twitter">
          <i class="fa fa-twitter"></i>
        </a>

    </div>
    <div class="text-center text-muted">
      <p>&copy; All rights reserved Nisa Champagne.
      </p>
    </div>
  </footer>